import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { ArrowDown, ArrowUp } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { PENDENCY_FAB_TEST_ID } from '../../objectScreen.constants';
import { usePendencyFab } from './hooks/usePendencyFab';

interface DetailsPendencyFabProps {
  scrollNode: HTMLElement | null;
}

const DetailsPendencyFab = ({ scrollNode }: DetailsPendencyFabProps) => {
  const { translate } = useTranslation();
  const { isVisible, direction, scrollToNextPendency } = usePendencyFab(scrollNode);

  if (!isVisible) {
    return null;
  }

  const isPointingUp = direction === 'up';

  return (
    <Stack
      component="button"
      type="button"
      direction="row"
      test-id={PENDENCY_FAB_TEST_ID}
      aria-label={translate(LangEnum.GLOBAL_GO_TO_NEXT_PENDENCY)}
      onClick={scrollToNextPendency}
      sx={(theme) => ({
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        ...(isPointingUp ? { top: theme.spacing(1) } : { bottom: theme.spacing(1) }),
        zIndex: 1,
        alignItems: 'center',
        gap: 0.5,
        px: 1.25,
        py: 0.5,
        border: 1,
        borderColor: theme.palette.custom.border.secondary,
        borderRadius: `${theme.shape.borderRadiusFull}px`,
        bgcolor: 'background.paper',
        boxShadow: theme.shadows[8],
        cursor: 'pointer',
        '&:hover': { bgcolor: 'action.hover' },
      })}
    >
      <Box sx={{ display: 'inline-flex', color: 'error.main' }}>
        <Icon icon={isPointingUp ? ArrowUp : ArrowDown} size="md" />
      </Box>
      <Typography variant="body2" noWrap sx={{ color: 'text.primary' }}>
        {translate(LangEnum.GLOBAL_PENDENCIES)}
      </Typography>
    </Stack>
  );
};

export default DetailsPendencyFab;
